@if (index === 1 && Inputdata.checkingItems !== 'newImages') {
  <div
    class="modal-body bg-gris-1 w-100"
    style="height: 340px; overflow-x: hidden"
    id="csv-id"
  >
    <h2 class="text-1 fs-4 text-center mb-4">
      {{ 'COMMON.Upload Document' | translate }}
    </h2>
    <div class="d-flex justify-content-center gap-5">
      <div class="text-center d-flex flex-column">
        <div class="variants">
          <div class="file">
            <label for="input-file">
              <img src="assets/img/home/laptop 1.png" />
            </label>
            <input
              id="input-file"
              #csvReader
              name="Upload CSV"
              type="file"
              (change)="handleFileInput($event)"
              accept=".csv"
            />
          </div>
        </div>
        <label for="select-upload-3" role="button" class="text-3 mt-3">{{
          'COMMON.My Computer' | translate
        }}</label>
        @if (Inputdata.checkingItems !== 'value') {
          <a [href]="downloadcsv" class="mt-4 sampletxt" target="_blank">{{
            'COMMON.DownloadCSV' | translate
          }}</a>
        }
        @if (Inputdata.checkingItems == 'value') {
          <a
            class="mt-4 sampletxt"
            role="button"
            tabindex="0"
            (click)="downloadItemCsvSample()"
            (keydown.enter)="downloadItemCsvSample()"
            (keydown.space)="downloadItemCsvSample(); $event.preventDefault()"
          >{{
            'COMMON.DownloadCSV' | translate
          }}</a>
          <app-item-csv-help></app-item-csv-help>
        }
        @if (
          Inputdata?.checkingItems !== 'value' &&
          remaining &&
          remaining.limit != false
        ) {
          <p>
            {{
              'ITEMS.ContactLimitRemaining'
                | translate: { limit: remaining.limit }
            }}
            <a href="/dash/profile">here</a>
          </p>
        }
        @if (remaining == false) {
          <p class="text-danger">
            @if (canManagePlanAddons) {
              {{ 'PROFILE.CONTACTLIMITEXCEEED' | translate }}
              <a href="/dash/profile/?tab=nav-plan-tab">here</a>
            } @else {
              {{ 'PROFILE.CONTACTLIMITEXCEEED_NO_PLAN_ACCESS' | translate }}
            }
          </p>
        }
      </div>
    </div>
  </div>
}
@if (index === 3) {
  <div
    class="modal-body bg-gris-1 w-100"
    style="overflow-x: hidden; overflow-y: scroll"
    id="csv-id"
  >
    <h2 class="text-1 fs-4 text-center mb-2">
      {{ 'ITEMS.Upload CSV File' | translate }}
    </h2>
    <h4>{{ 'ITEMS.Upload CSV File Sub Text' | translate }}</h4>
    <div class="table-design" style="overflow: scroll; max-height: 400px">
      <table class="table table-bordered">
        <div>
          <thead>
            <tr>
              <!-- Only render the column header if the heading name is not "Images" -->
              @for (heading of headingdata; track heading) {
                @if (heading.name !== 'Images') {
                  <th>
                    {{
                      getTranslatedText('COMMON.' + heading.name) ||
                        heading.name
                    }}
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- Only render the data cell if the heading name is not "Images" -->
              @for (heading of headingdata; track heading) {
                @if (heading.name !== 'Images') {
                  <td>
                    @for (
                      data of heading.valueData | slice: 0 : 10;
                      track data
                    ) {
                      <div class="customtable-changed">
                        {{
                          data?.toString()?.length > 20
                            ? data?.toString().slice(0, 20) + '...'
                            : data?.toString()
                        }}
                      </div>
                    }
                  </td>
                }
              }
            </tr>
          </tbody>
        </div>
      </table>
    </div>
    <div class="text-3 d-flex gap-3 mt-1">
      <!-- <p>Records: <b class="fw-normal text-1">{{dataarryCsc.length && 2 >= dataarryCsc.length?dataarryCsc.length:2}}</b></p> -->
      <p>
        {{ 'QUOTE_TEMPLATE.Records' | translate }}:
        <b class="fw-normal text-1">{{ records }}</b>
      </p>
      <p>
        {{ 'QUOTE_TEMPLATE.Column' | translate }}:
        <b class="fw-normal text-1">{{ headingdata.length }}</b>
      </p>
      <p>
        {{ 'QUOTE_TEMPLATE.File Size' | translate }}:
        <b class="fw-normal text-1">{{ filesize }}</b>
      </p>
    </div>
  </div>
}

@if (index === 2) {
  <div
    class="modal-body bg-gris-1 w-100"
    style="height: 400px; overflow-x: hidden; overflow-y: scroll"
    id="csv-id"
  >
    <h2 class="text-1 fs-4 text-center mb-3">
      {{ 'ITEMS.Upload CSV File' | translate }}
    </h2>
    @for (item of headingdata; track item; let i = $index) {
      <div
        class="d-flex align-items-center text-break align-items-center gap-3 my-3 px-2"
      >
        <p class="text-3 col-4 !mb-0">
          {{ getTranslatedText('COMMON.' + item.name) || item.name }}
          @if (item.star) {
            <span class="color-6">*</span>
          }
          :
        </p>
        <mat-form-field>
          <mat-select
            [disabled]="item.name == 'Id'"
            [(ngModel)]="item.valueData"
            [placeholder]="'COMMON.Select' | translate"
            name="mat-select-{{ i }}"
            (selectionChange)="onOptionsSelected($event, item.options)"
            [required]="item.star"
            [multiple]="isMultipleField(item.name)"
            placeholder="Select"
            (click)="onClickChangeOptions($event, item.options)"
          >
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="item.searchTxt"
                [placeholderLabel]="'COMMON.Search' | translate"
              >
              </ngx-mat-select-search>
            </mat-option>
            @if (!isMultipleField(item.name)) {
              <mat-option (click)="noOptionSelection($event, item.options)">{{
                'COMMON.Select' | translate
              }}</mat-option>
            }
            @for (
              item2 of allcsvlisting | search: item.searchTxt;
              track item2
            ) {
              <mat-option
                [value]="item2.id.trim()"
                (click)="
                  optionSelection(
                    $event,
                    item2.id.trim(),
                    isMultipleField(item.name)
                      ? [item.valueData]
                      : item.valueData,
                    item2.name,
                    item.name
                  )
                "
                [disabled]="isOptionDisabled(item2.id.trim())"
              >
                {{ item2.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
}
@if (index === 4) {
  <div
    class="modal-body bg-gris-1 w-100"
    style="height: 300px; overflow-x: hidden; overflow-y: scroll"
    id="csv-id"
  >
    <h2 class="text-1 fs-4 text-center mb-3">
      {{ 'ITEMS.Upload CSV File' | translate }}
    </h2>
    <form [formGroup]="csvform">
      <div
        class="text-3 pb-4"
        [ngClass]="{ 'border-bottom mb-4': emaildata.length != 0 }"
      >
        <div class="d-flex gap-3 align-items-center upload_tags">
          <p style="margin: 0px; margin-bottom: 0px">
            {{ 'COMMON.Tags' | translate }}:
          </p>
          <div class="w-100">
            <input
              class="form-control border-gris"
              style="text-align: left !important; padding: 4px 6px !important"
              formControlName="tag"
              type="text"
              placeholder="Enter Tag Name"
            />
          </div>
        </div>
        @if ((sub || f.tag.touched) && f.tag.errors) {
          <div class="invalid-feedback" style="padding-left: 9%">
            @if (f.tag.errors.required) {
              <div>{{ 'ITEMS.Tag is Required' | translate }}</div>
            }
          </div>
        }
      </div>
      <!-- <div class="color-2 d-flex align-items-center gap-3" *ngIf="emaildata.length != 0">
                <p style="margin: 0px;">{{emaildata.length}} emails already exist</p>
                <i class="fas fa-check-circle fs-4"></i>
            </div> -->
      @if (showOption != false) {
        <div class="d-flex align-items-center gap-2 my-3 create_update_select">
          <!-- <p class="text-3" style="width: 200%;">{{"ITEMS.Based on status above select your option:" |
                    translate}}</p> -->
          <select
            class="form-select border-gris w-100"
            formControlName="status"
            type="text"
          >
            <option value="create" [disabled]="remaining === false">
              {{
                'ITEMS.Create the new contact if found the duplicate'
                  | translate
              }}
            </option>
            <option value="update" [disabled]="remaining === false">
              {{
                'ITEMS.Upload Only New Contacts and Skip Duplicates' | translate
              }}
            </option>
            <option value="update_replace">
              {{
                'ITEMS.Edit contact details. Update information with new data'
                  | translate
              }}
            </option>
          </select>
          @if ((sub || f.status.touched) && f.status.errors) {
            <div class="invalid-feedback">
              @if (f.status.errors.required) {
                <div>{{ 'ITEMS.Status is Required' | translate }}</div>
              }
            </div>
          }
        </div>
      }

      @if (showOption == false) {
        <div class="d-flex align-items-center gap-2 my-3 create_update_select">
          <!-- <p class="text-3" style="width: 200%;">{{"ITEMS.Based on status above select your option:" |
                    translate}}</p> -->
          <select
            class="form-select border-gris w-100"
            formControlName="item_status"
            type="text"
          >
            <option value="item_create">
              {{ 'ITEMS.Create_new_items' | translate }}
            </option>
            <option value="item_update">
              {{ 'ITEMS.Upload_only_new' | translate }}
            </option>
            <option value="item_update_replace">
              {{ 'ITEMS.Modify_Items' | translate }}
            </option>
          </select>
          <!-- <div *ngIf="(sub || f.status.touched) && f.status.errors" class="invalid-feedback">
                    <div *ngIf="f.status.errors.required">{{ "ITEMS.Status is Required" |translate}}</div>
                </div> -->
        </div>
      }

      <div class="d-flex gap-2">
        <input
          class="form-check-input col-1"
          formControlName="Confirm"
          type="checkbox"
          [checked]="checkbox1"
          value=""
          id="flexCheckDefault"
        />
        <p class="text-3">
          {{ 'COMMON.CSVTerms' | translate }}
        </p>
        @if ((sub || f.Confirm.touched) && f.Confirm.errors) {
          <div class="invalid-feedback">
            @if (f.Confirm.errors.required) {
              <div>{{ 'ITEMS.Status is Required' | translate }}</div>
            }
          </div>
        }
      </div>
    </form>
  </div>
}
@if (index === 5) {
  <div class="modal-body bg-gris-1 p-5 d-flex flex-column align-items-center">
    <img src="assets/img/home/cloud.png" />
    <h2 class="text-1 fs-4 text-center my-4">
      {{ 'ITEMS.Upload CSV File' | translate }}
    </h2>
    <p class="text-3 mb-5">{{ 'ITEMS.ContactProcessDone' | translate }}</p>
    <button class="btn btn-1" (click)="csvUpload()">
      {{ 'COMMON.Done' | translate }}
    </button>
  </div>
}

<!-- Say out loud which required columns the file did not supply. An import
     that silently drops one of these is how a 1,323-row contact file once
     landed with zero names, and how "Modify Items" can report success while
     changing nothing. -->
@if (missingRequiredColumns.length) {
  <div class="alert alert-warning d-flex align-items-start gap-2 mt-3 mb-0" role="alert">
    <mat-icon class="text-warning">warning</mat-icon>
    <div>
      <strong>{{ 'ON_BOARDING.unmapped_columns_title' | translate }}</strong>
      <div>{{ missingRequiredColumns.join(', ') }}</div>
      <small class="d-block mt-1">{{ 'ON_BOARDING.unmapped_columns_help' | translate }}</small>
    </div>
  </div>
}
<!-- Card #536: which rows the import refused, and why. -->
@if (index === 2 && csvRowProblemLines.length) {
  <div class="alert alert-danger d-flex align-items-start gap-2 mt-3 mb-0 csv-row-problems" role="alert">
    <mat-icon class="text-danger">error</mat-icon>
    <div>
      <strong>{{ 'ON_BOARDING.csv_row_problems_title' | translate }}</strong>
      <ul class="mb-0 mt-1 ps-3">
        @for (line of csvRowProblemLines; track $index) {
          <li>{{ line }}</li>
        }
      </ul>
    </div>
  </div>
}
@if (index !== 1 && index !== 5) {
  <div class="d-flex justify-content-center mt-4 gap-3">
    <button (click)="closebutton()" class="btn btn-2">
      {{ 'COMMON.Cancel' | translate }}
    </button>

    <button
      class="btn btn-1"
      type="submit"
      [disabled]="
        index == 4 ? csvform.controls['Confirm'].value === false : false
      "
      (click)="continue()"
    >
      {{ 'COMMON.Continue' | translate }}
    </button>
  </div>
}

<!-- <ng-container *ngIf="Inputdata.checkingItems == 'newImages'">
    <div class="modal-body bg-gris-1 p-5">
        <h2 class="text-1 fs-4 text-center mb-4">{{"Upload Images" | translate}}</h2>
        <div class="d-flex justify-content-center gap-5">
            
            <div class="text-center d-flex flex-column col-8 justify-content-center">
            
                <div class="variants col-12">
                    <div class='file col-12'>
                        <mat-select [formControl]="csvFile" multiple class="form-select mt-3 border-gris">
                            <mat-option *ngFor="let item of itemsCsvFile" [value]="item.id">{{item.name}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="d-flex flex-column align-center mt-3 gap-3">
                    <p class="text-3"></p>
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="item-image-box gap-2 cursor-pointer" style="width: 250px;" *ngIf="image">
                            <img class="edit-item-images" src="{{ imageUrl + image.image }}">
                            <div class="overlay"></div>
                            <div class="image-remove-btn">
                                <a (click)="removeItem(image,'imgRemove')">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>
                        <div class="bg-gris-2 p-2 ms-2 d-flex justify-content-center rounded-circle rounded-2"
                            style="width: 45px; height: 45px; background-color: rgb(3, 192, 252, 10%);">
                            <input type="file" name="file-6" id="file-6" class="inputfile"
                                data-multiple-caption="{count} archivos seleccionados"
                                (change)="imageFilesAddedEdit($event)" multiple />
                            <label for="file-6">
                                <img class="" width="33px" height="29.22px" src="assets/svg-icons/Group (2).svg">
                            </label>
                        </div>
                    </div>
                    <div class="d-flex gap-2" style="margin-top:20px">
                        <div class="item-image-box cursor-pointer gap-2"
                            *ngFor="let image of editItemsImages;let i = index" (click)="changeImage(i,image)"
                            style="width:80px; height: 70px;">
                            <img class="edit-item-image-zoom" src="{{ imageUrl + image.image }}">
                            <img class="edit-item-images" src="{{imageUrl +image.image}}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-4 gap-3">
        <button (click)="closebutton()" class="btn btn-2 mx-2">{{"PROFILE.cancel" |
            translate}}</button>

        <button class="btn btn-1 mx-2" [disabled]="!csvFile" (click)="contiineItems()">
            {{"ITEMS.Continue" | translate}}</button>
    </div>
</ng-container> -->

@if (Inputdata.checkingItems == 'newImages') {
  <div class="modal-body bg-gris-1" style="overflow: hidden">
    <div class="d-flex justify-content-end me-2">
      <mat-icon
        class="material-symbols-outlined icon_close color-1"
        role="button"
        (click)="closeDialog()"
        >close</mat-icon
      >
    </div>
    <h2 class="text-1 fs-4 text-center mb-2">
      {{ 'ITEMS.Upload_images' | translate }}
    </h2>
    <div class="table-design" style="overflow-y: scroll; height: 400px">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>{{ 'COMMON.NAME' | translate }}</th>
            <th>{{ 'COMMON.Item_Code' | translate }}</th>
            <th>{{ 'ITEMS.Upload_images' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of newItemsData?.data; track item; let i = $index) {
            <tr>
              <td>{{ item?.name }}</td>
              <td>
                <div>
                  {{
                    Inputdata?.value == 'allItems'
                      ? item?.code
                      : item?.item_code
                  }}
                </div>
              </td>
              <td>
                <div>
                  <button
                    class="btn btn-1 mx-2"
                    [ngClass]="item.disabled ? 'upload_images_check' : ''"
                    [matTooltip]="item.disabled ? 'Images uploaded' : ''"
                    (click)="
                      uploadItemImages(
                        Inputdata?.value == 'allItems'
                          ? { id: item.id, name: item.name }
                          : { id: item.item_id, name: item.name },
                        i
                      )
                    "
                  >
                    {{ 'COMMON.Upload' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- Additional information if needed -->
    <!-- <div class="text-3 d-flex gap-3 mt-1">
        <p>Records: <b class="fw-normal text-1">{{ dataarryCsc.length }}</b></p>
        <p>Columns: <b class="fw-normal text-1">{{ headingdata.length }}</b></p>
        <p>File Size: <b class="fw-normal text-1">{{ filesize }}</b></p>
      </div> -->
  </div>

  <div
    class="d-flex flex-col gap-3 justify-content-around align-items-baseline table-pagination mt-4 pl-3 pr-3"
    style="color: rgba(0, 0, 0, 0.54); font-size: 12px"
  >
    <div class="w-full flex justify-center items-center">
      <div class="flex gap-2" style="font-size: 12px">
        <label for="cars">{{ 'LEADS.Item_per_page' | translate }}</label>
        <select
          (change)="paginationPageSize($any($event.target).value)"
          style="height: 22px; width: 45px"
        >
          @for (size of defaultsPage.pageSizes; track size) {
            <option value="{{ size.value }}">{{ size.value }}</option>
          }
        </select>
      </div>
      <div class="pl-3" style="font-size: 12px">
        {{ pageDetail }}
      </div>
    </div>
    <nav
      class="w-full flex justify-center"
      aria-label="Page navigation example"
    >
      <ul class="pagination mb-0">
        <li
          class="page-item"
          [ngClass]="{ disabled: 1 === newItemsData?.currentPage }"
        >
          <a
            class="page-link text-3"
            href="javascript:void(0)"
            aria-label="Previous"
            (click)="paginationPage(newItemsData?.currentPage - 1)"
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        @for (page of visiblePages(); track page; let i = $index) {
          <li
            class="page-item"
            [ngClass]="{
              active: newItemsData?.currentPage === page,
              disabled: page === '...',
            }"
          >
            @if (page !== '...') {
              <a
                class="page-link text-3"
                href="javascript:void(0)"
                (click)="paginationPage(page)"
              >
                {{ page }}
              </a>
            }
            @if (page === '...') {
              <span>{{ page }}</span>
            }
          </li>
        }
        <li
          class="page-item"
          [ngClass]="{
            disabled: newItemsData?.totalPages === newItemsData?.currentPage,
          }"
        >
          <a
            class="page-link text-3"
            href="javascript:void(0)"
            aria-label="Next"
            (click)="paginationPage(newItemsData?.currentPage + 1)"
          >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
}
